export const getLanguageList = t => [{
  label: t('cfm_label_spanish'),
  value: 'es-es'
}, {
  label: t('cfm_label_en_uk'),
  value: 'en-gb'
}, {
  label: t('cfm_label_en_us'),
  value: 'en-us'
}, {
  label: t('cfm_label_fr'),
  value: 'fr-fr'
}, {
  label: t('cfm_label_it'),
  value: 'it-it'
}, {
  label: t('cfm_label_pt'),
  value: 'pt-pt'
}, {
  label: t('cfm_label_ru'),
  value: 'ru-ru'
}, {
  label: t('cfm_label_pt_br'),
  value: 'pt-br'
}, {
  label: t('cfm_label_de'),
  value: 'de-de'
}, {
  label: t('cfm_label_da'),
  value: 'da-dk'
}];
export const getValidationsTypesList = t => ['text', 'int', 'decimal', 'currency', 'datetime', 'percentage'].map(ty => ({
  label: t(`cfm_label_type_${ty}`),
  value: ty
}));
export const getFieldTypesList = t => ['text', 'list', 'multivalue', 'int', 'decimal', 'currency', 'datetime', 'bit', 'percentage'].map(ty => ({
  label: t(`cfm_label_type_${ty}`),
  value: ty
}));